enum ArtifactTypeFilter {
  IPA = 'ios-ipa',
  APK = 'android-apk',
}

export default ArtifactTypeFilter;
